module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sd-8": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-card-text', [_c('h1', [_vm._v("Nutri-Kiosk")]), _vm._v(" "), _c('p', [_vm._v("Pour comprendre la nutrition en s'amusant")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sd-4": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard"
  }, [_c('v-card-text', [_c('h1', [_vm._v("Nutri-Kiosk")]), _vm._v(" "), _c('p', [_vm._v("Pour comprendre la nutrition en s'amusant")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee5d43f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nutrikiosk/NutriKiosk.vue
// module id = 1218
// module chunks = 1